// client\src\services\categoryService.js

import axios from "axios";
import authHeader from "./authHeader";
import { API_URL } from "../utils/baseApi";

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const getCategories = () => {
  const apiKey = localStorage.getItem("apiKey");
  return axios.get(`${API_URL}/categories`, {
    headers: {
      "x-api-key": apiKey,
    },
  });
};

const createCategory = ({ name, image }) => {
  return axios.post(
    `${API_URL}/categories`,
    { name, image },
    { headers: authHeader() }
  );
};

const updateCategory = (id, { name, image }) => {
  return axios.put(
    `${API_URL}/categories/${id}`,
    { name, image },
    { headers: authHeader() }
  );
};

const deleteCategory = (id) => {
  return axios.delete(`${API_URL}/categories/${id}`, { headers: authHeader() });
};

const categoryService = {
  getCategories,
  createCategory,
  updateCategory,
  deleteCategory,
};

export default categoryService;
